import script from "./parent-task-plate.vue?vue&type=script&lang=ts&setup=true"
export * from "./parent-task-plate.vue?vue&type=script&lang=ts&setup=true"

import "./parent-task-plate.vue?vue&type=style&index=0&id=3ed49830&lang=scss"

const __exports__ = script;

export default __exports__